<ng-template #content>
  <ul
    *ngIf="arServicesAuthorized?.length > 1"
    id="menu-social"
    class="menu-social-horizontal navbar-round nav navbar-nav justify-content-center py-0 px-4 px-lg-5 mt-4"
    role="tablist"
  >
    <li
      [class.active]="item.type == allMessengersService.active"
      *ngFor="let item of arServicesAuthorized; let i = index"
      (click)="setActive(item)"
      class="nav-item outline-none"
    >
      <a class="nav-link position-relative p-0 pointer mx-2" title="{{ item.name }}">
        <i-feather class="logo-small" [name]="item.type | fixType"></i-feather>
      </a>
    </li>
  </ul>
  <div [style.min-height.px]="450" class="pb-3">
    <app-sign-telegram
      [type]="allMessengersService.active"
      [class.hidden]="!hasType('telegram')"
    ></app-sign-telegram>

    <app-sign-skype
      [class.hidden]="allMessengersService.active !== 'skype'"
      *ngIf="!skypeService.isAuth"
    ></app-sign-skype>

    <app-sign-whatsapp
      [class.hidden]="allMessengersService.active !== 'whatsapp'"
      *ngIf="!whatsappService.isAuth"
    ></app-sign-whatsapp>

    <app-sign-fellowdesk
      [class.hidden]="allMessengersService.active !== 'fellowdesk'"
      *ngIf="!fellowdeskService.isAuth"
    ></app-sign-fellowdesk>

    <app-sign-vk [class.hidden]="allMessengersService.active !== 'vk'" *ngIf="!vkService.isAuth"></app-sign-vk>
  </div>
</ng-template>

<ng-template [ngIf]="modalMode" [ngIfElse]="noModalContent">
  <div class="modal--wrap panel-show"
       ngxModalDraggable
       [expand]="false"
  >
    <app-modal-header
      icon="user-plus"
      title="Добавление аккаунта"
      [modalDirective]="modalDirective"
      [bsModalRef]="bsModalRef"
      [expand]="false"
      [minimized]="false"
    ></app-modal-header>
    <div class="modal-body p-0">
      <div #scroll class="h-100-sm">
        <ng-template [ngTemplateOutlet]="content"></ng-template>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noModalContent>
  <ng-template [ngTemplateOutlet]="content"></ng-template>
</ng-template>
